<template>
  <cube-popup
    type="toast"
    v-model:visible="visible"
    >
    <cube-loading ></cube-loading>
    <div v-show="content" class="cube-toast-tip" v-html="content"></div>
  </cube-popup>
</template>

<script>
import CubeLoading from '../Loading'
import CubePopup from '../Popup'

export default {
  components: {
    CubePopup,
    CubeLoading
  },
  props: {
    content: {
      type: String,
      default: 'Loading...'
    }
  },
  data() {
    return {
      visible: true
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>
